
<template>
    <div :id="id" v-loading="loading" class="vegaContain" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"></div>
</template>


<script>
import * as vega from "vega";

export default {
    name: "performance",
    props: {
        id: {
            type: String,
            required: true,
            default: "",
        },
    },
    components: {

    },

    data() {
        return {
            vegaView: {},
            loading: true,
            vegaDefaultConfig: {
                $schema: "https://vega.github.io/schema/vega/v5.json",
                padding: 0,
                autosize: "fit",
                title: {
                    color: "#fff", subtitleColor: "#fff",
                    text: "业绩快报不准确",
                    anchor: "middle",
                    fontSize: 16,
                    frame: "group",
                    offset: 4,
                },
                config: {
                    locale: {
                        time: {
                            periods: ["上午", "下午"],
                            days: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                            shortDays: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                            months: [
                                "1月",
                                "2月",
                                "3月",
                                "4月",
                                "5月",
                                "6月",
                                "7月",
                                "8月",
                                "9月",
                                "10月",
                                "11月",
                                "12月",
                            ],
                            shortMonths: [
                                "1月",
                                "2月",
                                "3月",
                                "4月",
                                "5月",
                                "6月",
                                "7月",
                                "8月",
                                "9月",
                                "10月",
                                "11月",
                                "12月",
                            ],
                        },
                    },
                },
                "signals": [
                    {
                        "name": "width",
                        "update": "containerSize()[0]",
                        "on": [
                            {
                                "events": { "source": "window", "type": "resize" },
                                "update": "containerSize()[0]"
                            }
                        ]
                    },
                    {
                        "name": "height",
                        "update": "containerSize()[1]",
                        "on": [
                            {
                                "events": { "source": "window", "type": "resize" },
                                "update": "containerSize()[1]"
                            }
                        ]
                    },
                    {
                        "name": "year",
                        "description": "年份",
                        "value": 2022

                    },
                    {
                        "name": "minTime",
                        "value": "time(datetime((year+1),0,1,0,0,0))",
                        "update": "time(datetime((year+1),0,1,0,0,0))"
                    },
                    {
                        "name": "maxTime",
                        "value": "time(datetime((year+1),11,31,59,59,59))",
                        "update": "time(datetime((year+1),11,31,59,59,59))"
                    }
                ],

                "data": [
                    {
                        "name": "table",
                        "values": [
                            { "id": 1, "field": 4 },
                            { "id": 2, "field": 6 },
                            { "id": 3, "field": 10 },
                            { "id": 4, "field": 3 },
                            { "id": 5, "field": 7 },
                            { "id": 6, "field": 8 }
                        ],
                        "transform": [
                            {
                                "type": "pie",
                                "field": "field"

                            }
                        ]
                    }
                ],

                "scales": [
                    {
                        "name": "color",
                        "type": "ordinal",
                        "range": { "scheme": "category20" }
                    }
                ],

                "marks": [
                    {
                        "type": "arc",
                        "from": { "data": "table" },
                        "encode": {
                            "enter": {
                                "fill": { "scale": "color", "field": "id" },
                                "x": { "signal": "width / 2" },
                                "y": { "signal": "height / 2" }
                            },
                            "update": {
                                "startAngle": { "field": "startAngle" },
                                "endAngle": { "field": "endAngle" },
                                "innerRadius": { "value": 0 },
                                "outerRadius": { "signal": "height / 3" }
                            }
                        }
                    }
                ]
            }
        }
    },
    methods: {
        vegaInit() {
            let width = document.getElementById(this.id).clientWidth;
            let height = document.getElementById(this.id).clientHeight;
            this.vegaDefaultConfig.width = width;
            this.vegaDefaultConfig.height = height;
            let aa = vega.parse(this.vegaDefaultConfig);
            var view = new vega.View(vega.parse(this.vegaDefaultConfig))
                .renderer("svg")
                .initialize("#" + this.id)
                .hover()
                .run();
            this.loading = false;
            this.vegaView = view;
        }
    },
    mounted() {
        this.vegaInit();
    }

}

</script>

<style></style>